export function surfaceOrigin(source, target) {
  if (!source || !target?.width) return { transform: 'translateY(12px) scale(.98)', clipPath: 'inset(0)' };
  const scale = source.width / target.width;
  const bottom = Math.max(0, 100 * (1 - source.height / (target.height * scale)));
  return {
    transform: `translate(${source.left - target.left}px, ${source.top - target.top}px) scale(${scale})`,
    clipPath: `inset(0 0 ${bottom}% 0)`,
  };
}

// Capture the presentation before cancelling so a close during opening starts
// at the actual frame on screen.
export function animateSurface(element, target, { from, previous, duration = 380, reduced = false } = {}) {
  const style = getComputedStyle(element);
  const current = { transform: style.transform, clipPath: style.clipPath, opacity: style.opacity };
  previous?.cancel();
  return element.animate(reduced
    ? [{ opacity: from?.opacity ?? current.opacity }, { opacity: target.opacity ?? 1 }]
    : [from || current, target], {
    duration: reduced ? 100 : duration,
    easing: 'cubic-bezier(.22,1,.36,1)',
    fill: 'both',
  });
}
